(function () {
    "use strict";

    angular.module("app").component("habilFvm", {
        templateUrl: "@/clearance/clearance-company.html",
        controller: ClearanceController,
        controllerAs: "vm",
        bindings: {
            clearance: "=",
            dossier: "=",
        }
    });

    ClearanceController.$inject = ["$rootScope", "HabilNavigator", "habilDate",];
    function ClearanceController($rootScope, HabilNavigator, habilDate) {
        const vm = Object.assign(this, {
            getStyle,
            openOrg,
        });

        vm.VMTypes = $rootScope.codeVMTypes;
        vm.VMLevels = $rootScope.codeIVMLevels;

        function getStyle() {
            if (!vm.clearance)
                return "";

            const today = habilDate.GetDateOnly(new Date());
            const warningDate = habilDate.AddMonths(today, 12);
            const expirationDate = habilDate.GetDateOnly(vm.clearance.DateValidTo);

            if (expirationDate.valueOf() < today.valueOf())
                return "bg-danger";
            if (expirationDate.valueOf() < warningDate.valueOf())
                return "bg-warning";

            return "bg-success";
        }

        function openOrg() {
            if (vm.dossier) {
                HabilNavigator.OpenDossierOrganisation(vm.dossier.PublicId);
            }
        }
    }
})();